import cx from 'classnames';
import styles from '../components/Icons/Icons.module.scss';
import CabinetIcon from './raw/cabinet.svg?react';
import type { IconProps } from './types';

const Cabinet = ({
  className,
  iconClass = true,
  label,
  style,
  viewBox,
}: IconProps) => (
  <CabinetIcon
    aria-labelledby={label}
    title={label}
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    viewBox={viewBox || '0 0 24 24'}
    className={cx({
      [styles.svgIcon]: iconClass,
      ...(className
        ? {
            [styles[className]]: className && styles[className],
            [className]: className && !styles[className],
          }
        : {}),
    })}
    style={style}
  />
);

export default Cabinet;
